import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="card p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">
          {t('privacy.title')}
        </h1>
        
        <div className="prose prose-sm max-w-none">
          <>
            <h2 className="text-lg font-semibold mb-2">{t('privacy.1.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('privacy.1.item.required')}</li>
              <li>{t('privacy.1.item.optional')}</li>
              <li>{t('privacy.1.item.auto')}</li>
            </ul>

            <h2 className="text-lg font-semibold mb-2">{t('privacy.2.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('privacy.2.item.service')}</li>
              <li>{t('privacy.2.item.content')}</li>
              <li>{t('privacy.2.item.monitoring')}</li>
              <li>{t('privacy.2.item.improvement')}</li>
            </ul>

            <h2 className="text-lg font-semibold mb-2">{t('privacy.3.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('privacy.3.item.delete')}</li>
              <li>{t('privacy.3.item.law')}</li>
            </ul>

            <h2 className="text-lg font-semibold mb-2">{t('privacy.4.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('privacy.4.item.access')}</li>
              <li>{t('privacy.4.item.deletion')}</li>
            </ul>

            <h2 className="text-lg font-semibold mb-2">{t('privacy.5.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('privacy.5.item.principle')}</li>
              <li>{t('privacy.5.item.entrust')}</li>
            </ul>

            <h2 className="text-lg font-semibold mb-2">{t('privacy.6.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('privacy.6.item.security')}</li>
            </ul>

            <h2 className="text-lg font-semibold mb-2">{t('privacy.7.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('privacy.7.item.menu')}</li>
              <li>{t('privacy.7.item.immediate')}</li>
            </ul>
          </>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;

